module.exports = __webpack_public_path__ + "static/img/Logo_Afsi_OLD.89d6bee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/support/Logo_Afsi_OLD.png
// module id = i+SY
// module chunks = 36